import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "./ReservationForm.css";
import { useRef } from "react";
import { Button, Modal } from "react-bootstrap";

const ReservationForm = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_lqva9eg",
        "template_9gk4u9o",
        form.current,
        "Y3bIpNjzgjkZ9FV_W"
      )
      .then(
        (result) => {
          console.log(result);
          if (result.text === "OK") {
            // alert("Sucessfully Sent");
            handleShow();
            e.target.reset();
          }
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  //sucess modal

  //    const [senderName, setSenderName] = useState('');
  //    const [phoneNumber, setPhoneNumber] = useState('');
  //    const [person, setPerson] = useState('');
  //    const [reserve_date, setReserve_date] = useState('');
  //    const [selectTime, setSelectTime] = useState('');
  //    const [description, setDescription] = useState('');

  //    console.log(senderName, phoneNumber, person, reserve_date, selectTime, description)

  //    const handleName = (e) =>{
  //         setSenderName(e.target.value);
  //    }
  //    const handleTelephone = (e) =>{
  //     setPhoneNumber(e.target.value);
  //    }
  //    const handlePerson = (e) =>{
  //     setPerson(e.target.value);
  //    }
  //    const handleDate = (e) =>{
  //     setReserve_date(e.target.value);
  //    }
  //    const handleTime = (e) =>{
  //     setSelectTime(e.target.value);
  //    }
  //    const handleDescription = (e) =>{
  //     setDescription(e.target.value);
  //    }

  //    const sendEmail = (e)=>{
  //         e.preventDefault();
  //         e.target.value = " ";
  //         send(
  //             'service_nay94pi',
  //             'template_odv4ptp',
  //             {senderName, phoneNumber, person, reserve_date, selectTime, description},
  //             'XN8EYN1hgQPXk6VhJ'
  //         )
  //         .then((response) => {
  //             console.log('message sent successfully', response.status, response.text)
  //         })
  //         .catch((err)=>{
  //             console.log("Did't sent", err)
  //         })

  //    }

  return (
    <section className="py-5">
      {/* <div className='reservation-banner-background-overlay'></div> */}
      <div className="row gx-0 py-3 py-md-5 d-flex justify-content-center align-items-center">
        <div className="col-12 col-md-6 text-center d-flex flex-column justify-content-center align-items-center big_fonts_opti">
          <h2 style={{ fontSize: "3rem" }}>Réservation EN Ligne</h2>
          <h6>Réservez votre table pour le déjeuner ou le dîner.</h6>
        </div>
      </div>
      <div className="row gx-0 py-5 d-flex justify-content-center align-items-center">
        <div className="col-11 col-md-6 d-flex justify-content-center align-items-center">
          {/* <form className="contact-input-field"> */}
          <form
            className="row gx-0 w-100 reserve-input-field"
            ref={form}
            onSubmit={sendEmail}
          >
            <div className="col-12">
              <div className="row gx-2 d-flex flex-column flex-md-row justify-content-center align-items-center">
                <div className="col-12 col-md-6">
                  {/* <input className="" type="text" name="senderName" value={senderName} placeholder="Nom *" onChange={handleName}/> */}
                  <input
                    className=""
                    type="text"
                    required
                    name="user_name"
                    placeholder="Nom *"
                  />
                </div>
                <div className="col-12 col-md-6">
                  {/* <input className="" type="text" name="phoneNumber" vlaue={phoneNumber} placeholder="Numéro De Téléphone *" onChange={handleTelephone}/> */}
                  <input
                    className=""
                    type="text"
                    required
                    name="user_number"
                    placeholder="Numéro De Téléphone *"
                  />
                </div>
              </div>
              <div className="row gx-2 d-flex justify-content-center align-items-center">
                <div className="col-12 col-md-4">
                  {/* <select className="w-100 slected_Person" name="persons" id="persons" value = {person} onChange={handlePerson}> */}
                  <select className="w-100 " name="user_persons" id="persons">
                    <option value="1 Person">1 Personne</option>
                    <option value="2 Person">2 Personne</option>
                    <option value="3 Person">3 Personne</option>
                    <option value="4 Person">4 Personne</option>
                    <option value="5 Person">5 Personne</option>
                  </select>
                </div>
                <div className="col-12 col-md-4">
                  {/* <input className="w-100" type="date" id="reserve-date" value={reserve_date} name="reserve-date" onChange={handleDate} /> */}
                  <input
                    className="w-100"
                    type="date"
                    id="reserve-date"
                    name="user__reserveDate"
                  />
                </div>
                <div className="col-12 col-md-4">
                  {/* <select className="w-100" name="selectTime" value={selectTime} id="persons" onChange={handleTime}> */}
                  <select className="w-100" name="user_selectTime" id="persons">
                    <option value="7pm">7:00 pm</option>
                    <option value="8pm">8:00 pm</option>
                    <option value="9pm">9:00 pm</option>
                    <option value="10pm">10:00 pm</option>
                    <option value="11pm">11:00 pm</option>
                  </select>
                </div>
              </div>
              <div className="col-12 col-md-12">
                {/* <textarea id="description" placeholder="Special Request" name="description" value={description} rows="5" cols="33" onChange={handleDescription}></textarea> */}
                <textarea
                  id="description"
                  required
                  placeholder="Special Request"
                  name="user_description"
                  rows="5"
                  cols="33"
                ></textarea>
              </div>
              <div className="col-12 col-md-12">
                <button
                  className="animated-button victoria w-100"
                  value="send"
                  type="submit"
                >
                  Réserver Une Table
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {show && (
        <Modal
          className="justify-content-center align-items-center"
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title className="text-center py-5">
              Reservation Requirement Successfully Sent! For Confarmation We
              Call You Very Soon! Thanks
            </Modal.Title>
          </Modal.Header>
          <body></body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </section>
  );
};

export default ReservationForm;
